<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <g clip-path="url(#clip0_3592_815)">
      <path
        d="M24.7074 8.80396C22.9618 8.80396 21.3144 9.42228 20 10.5583C18.6856 9.42233 17.0382 8.80396 15.2926 8.80396C11.2715 8.80396 8 12.1342 8 16.2275C8 18.1687 8.74644 19.9991 10.1019 21.3814C10.195 21.4764 19.4173 30.8814 19.5158 30.9824H19.5158C19.5183 30.985 19.5207 30.9874 19.5231 30.9898C19.6551 31.1219 19.8341 31.1958 20.0203 31.1958C20.028 31.1958 20.0359 31.1957 20.0436 31.1954C20.2265 31.1893 20.3992 31.1123 20.5258 30.9815C20.6704 30.8333 29.8457 21.4762 29.9386 21.3814C31.2872 20.0061 32 18.2239 32 16.2275C32 12.1342 28.7285 8.80396 24.7074 8.80396ZM20.0644 12.2299C21.0905 12.2299 21.9252 13.0647 21.9252 14.0907C21.9252 14.903 21.5918 15.694 21.0103 16.2613L20.0589 17.1718L19.1206 16.2635C18.5378 15.696 18.2036 14.904 18.2036 14.0907C18.2037 13.0647 19.0384 12.2299 20.0644 12.2299ZM9.40625 16.2275C9.40625 12.9096 12.0469 10.2102 15.2926 10.2102C16.4644 10.2102 17.5817 10.5577 18.5353 11.2048C17.5025 11.7542 16.7974 12.8414 16.7974 14.0907C16.7974 15.2812 17.2866 16.4404 18.1411 17.2724L19.0422 18.1447L13.8085 23.153L11.1059 20.3969C9.99402 19.2628 9.40625 17.8212 9.40625 16.2275ZM20.0203 29.4882L14.7931 24.1573L20.0533 19.1235L25.2503 24.1543L20.0203 29.4882ZM28.9346 20.3969L26.2348 23.1502L21.0701 18.1506L21.9849 17.2753C21.9863 17.2738 21.9878 17.2724 21.9893 17.271C22.8422 16.4404 23.3315 15.2812 23.3315 14.0907C23.3315 12.8121 22.5928 11.7035 21.5203 11.1672C22.4616 10.5441 23.5584 10.2102 24.7075 10.2102C27.9531 10.2102 30.5938 12.9096 30.5938 16.2275C30.5938 17.8482 30.02 19.2899 28.9346 20.3969Z"
        fill="#040325"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_815">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(8 8)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
